export var ModalOpen = {
    bind: function (element, binding, vNode) {
        element.addEventListener("click", function () {
            vNode.context.$root.$emit('open-modal', binding.value);
        });
    }
};
export var ModalClose = {
    bind: function (element, binding, vNode) {
        element.addEventListener("click", function () {
            vNode.context.$root.$emit('close-modal', binding.value);
        });
    }
};
